import {commonEL} from "../locales/el/common";
import {commonEN} from "../locales/en/common";
import {commonDE} from "../locales/de/common";
import {commonES} from "../locales/es/common";
import {commonFR} from "../locales/fr/common";
import {commonIT} from "../locales/it/common";
import {commonAR} from "../locales/ar/common";
import {commonAL} from "../locales/sq/common";
import {commonTR} from "../locales/tr/common";
import {commonBG} from "../locales/bg/common";

export const pickLanguageWord = (language, word) => {
    switch (language){
        case "el" : {
            return commonEL[`${word}`];
        }
        case "en" : {
            return commonEN[`${word}`];
        }
        case "de" : {
            return commonDE[`${word}`];
        }
        case "es" : {
            return commonES[`${word}`];
        }
        case "fr" : {
            return commonFR[`${word}`];
        }
        case "it" : {
            return commonIT[`${word}`];
        }
        case "sq" : {
            return commonAL[`${word}`];
        }
        case "ar" : {
            return commonAR[`${word}`];
        }
        case "tr" : {
            return commonTR[`${word}`];
        }
        case "bg" : {
            return commonBG[`${word}`];
        }
        default : {
            return commonEN[`${word}`];
        }
      }
}